import { Body, Container, Footer, Row } from './SkeletonReview.styled';

const SkeletonReview = () => {
	return (
		<Container>
			<Row width={250} />
			<Row width={141} />
			<Body>
				<Row width={48} />
				<Row width={190} />
				<Row width={48} />
				<Row width={190} />
				<Row width={48} />
				<Row width={190} />
				<Row width={48} />
				<Row width={190} />
				<Row width={48} />
				<Row width={190} />
			</Body>
			<Footer />
		</Container>
	);
};

export default SkeletonReview;
